import { onMount } from "solid-js";

export default function TrafficJunkyScript() {
  onMount(() => {
    const trafficjunkyScript = document.createElement("img");
    trafficjunkyScript.src =
      "https://ctrack.trafficjunky.net/ctrack?action=list&type=add&id=0&context=Prelanders&cookiename=MindscraperDSPPrelanderFirstClickRetargetingPixelWorking&age=86400&maxcookiecount=10";
    document.body.appendChild(trafficjunkyScript);
  });

  return null;
}
